<template>
  <div class="root">
    <div class="searchDiv">
      <div class="searchmodel">
        <el-input
          v-model="keyword"
          @keyup.enter.native="getList"
          placeholder="请输入关键字搜索"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="getList"
          ></i>
        </el-input>
      </div>
    </div>
    <ul class="ul_left">
      <li>
        <div
          class="image"
          :style="{
            'background-color': '#2187FF',
          }"
        >
          <div style="text-align: center; flex: 1">
            <span style="color: #fff">鉴证书</span>
          </div>
          <img src="../assets/img/鉴证书0.png" alt />
        </div>
      </li>
    </ul>
    <ul class="ul_right">
      <li class="li_right" v-for="(item, index) in titles" :key="index">
        <router-link :to="{ name: '鉴证书详情', query: { id: item.id } }"
          >{{ item.position }}{{ item.projectName }}</router-link
        >
        <p>
          <span style>{{ item.signDate }}</span>
          <!-- <span>来源：{{item.source}}</span> -->
        </p>
      </li>
    </ul>

    <div v-if="total > 0">
      <el-pagination
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <h3 v-else style="font-size: 24px">暂无数据</h3>
  </div>
</template>

<script>
import request from '@/util/request'
export default {
  data () {
    return {
      titles: [],
      //   每页数据条数
      pageSize: 10,
      currentpage: 1,
      inputpage: 1,
      total: 0,
      keyword: '',
    }
  },
  created () {
    // 鉴证书数据
    // let url = "jianzhegnshuliebiao";
    // console.log('鉴证书');
    // console.log(this.ajax_url(url).data);
    // this.titles = this.ajax_url(url).data;
    request({
      method: 'post',
      url: '/api/attest',
      data: {
        pageSize: this.pageSize,
        pageNum: this.currentpage,
      },
      params: {
        pageSize: this.pageSize,
        pageNum: this.currentpage,
      },
    }).then((res) => {
      console.log(res)
      this.titles = res.data.rows
      this.total = res.data.total
    })
  },
  mounted () {
  },
  computed: {},
  watch: {},
  methods: {
    getList () {
      request({
        method: 'post',
        url: '/api/attest',
        data: {
          pageSize: this.pageSize,
          pageNum: this.currentpage,
          keyword: this.keyword,
          searchValue: this.keyword,
        },
        params: {
          pageSize: this.pageSize,
          pageNum: this.currentpage,
          keyword: this.keyword,
          searchValue: this.keyword,
        },
      }).then((res) => {
        console.log(res)
        this.titles = res.data.rows
        this.total = res.data.total
      })
    },
    // 当前每夜多少条
    handleSizeChange (size) {
      this.pageSize = size
    },
    // 当前页数
    handleCurrentChange (currentpage) {
      this.currentpage = currentpage
    },
  },
}
</script>

<style scoped>
.root {
  min-height: 1180px;
  margin: 0 auto;
  margin-bottom: 35px;
  width: 1860px;
  max-height: 1393px;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  opacity: 1;
  overflow: hidden;
}
.ul_left {
  display: block;
  width: 260px;
  height: auto;
  float: left;
  /* background-color: rebeccapurple; */
  padding: 40px 40px;
  list-style: inside none;
}
.ul_left > li {
  display: block;
  width: 260px;
  height: 92px;
  /* background-color: red; */
  margin-bottom: 20px;
  cursor: pointer;
}

.image {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  padding-right: 30px;
  font-size: 22px;
  font-weight: bold;
}
.ul_right {
  display: block;
  width: 1300px;
  max-height: 1230px;
  overflow: hidden;
  list-style: inside none;
  margin-bottom: 40px;
}

.ul_right .li_right {
  display: block;
  width: 1300px;
  height: 122px;
  border-bottom: 1px dotted #bebebe;
}

.li_right > a {
  display: block;
  padding: 37px 0 19px 0;
  max-width: 1200px;
  height: 26px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 26px;
  color: #666666;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.li_right > p {
  display: block;
  width: auto;

  height: 21px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 21px;
  color: #999999;
}

.li_right > p > span {
  display: inline-block;
  width: 250px;
}

.el-pagination {
  text-align: center;
}
.searchmodel /deep/.el-input {
  font-size: 22px;
  /* border: 1px solid red; */
  text-align: left;
}

.searchmodel /deep/.el-input__inner {
  height: 50px;
  width: 300px;
  border: 1px solid #747474;
  border-radius: 10px;
  /* font-size: 16px; */
}

.searchmodel {
  /* margin-left: 500px; */
  width: 300px;
  padding: 0 30px;
  margin-top: 10px;
}
</style>
